import { Suffix } from '@shared/enums';

export const getSuffixOptions = () => {
  return Object.entries(Suffix).map(([key, value]) => ({
    value: key,
    label: value,
  }));
};
